module.exports = __webpack_public_path__ + "static/img/toolbox-tiled.d14b46f5.svg";